(function ($){

    let product_toast = new bootstrap.Toast('#product-toast');

    $('body').on('click', '[data-compare-btn]', function(){
        let that = $(this);

        compareProduct(that);
    });

    function compareProduct(el){
        let product_id = el.attr('data-compare-btn'),
            current_products_compare = Cookies.get('products_compare'),
            title = el.attr('data-product-title'),
            all_buttons = $('.product-controls-button [data-compare-btn="'+ product_id +'"]');

        // check cookie of compare
        if(current_products_compare === undefined){
            current_products_compare = [];
        } else {
            current_products_compare = JSON.parse(current_products_compare);
        }

        if(el.is('.remove')){
            current_products_compare.remove_array_item(product_id);
            all_buttons.removeClass('remove');

            insert_to_product_toast('<b>' + title +'</b> ' + TOAST_TEXT_REMOVE_FROM_COMPARE);

            // remove cols on compare page
            if(el.is('[data-col-number-id]')){
                let col_id = el.attr('data-col-number-id');

                if(current_products_compare.length < 1){
                    $('.compare').remove();
                    $('#compare-not-found').show();
                } else {
                    $('[data-col-number="' + col_id + '"]').remove();
                }
            }
        } else {
            current_products_compare.push(product_id);
            all_buttons.addClass('remove');

            insert_to_product_toast('<b>' + title +'</b> ' + TOAST_TEXT_ADD_TO_COMPARE);
        }
        Cookies.set('products_compare',  JSON.stringify(current_products_compare), {});

        // show total count
        $('[data-compare-counter]').text(current_products_compare.length);

        // show toast
        product_toast.show();
    }
}(jQuery));
